(() => {
  function alignFinderCopy(root = document) {
    const heroLink = root.querySelector('[class*="ai-hero-text-link-"][href*="/pages/test-selector"]');
    if (heroLink) {
      heroLink.textContent = 'Find products by screening target';
      heroLink.setAttribute('aria-label', 'Open the NomaCare Product Finder');
    }

    const secondaryLink = root.querySelector('[class*="ai-lead-capture-secondary-button-"][href*="/pages/test-selector"]');
    if (secondaryLink) {
      secondaryLink.replaceChildren(document.createTextNode('Open Product Finder '));
      const arrow = document.createElement('span');
      arrow.setAttribute('aria-hidden', 'true');
      arrow.textContent = '→';
      secondaryLink.append(arrow);
      secondaryLink.setAttribute('aria-label', 'Open the NomaCare Product Finder');
    }

    const note = root.querySelector('[class*="ai-lead-capture-note-"]');
    if (note) {
      note.textContent = 'Compare products by stated screening target. This tool does not diagnose a condition or provide a medical recommendation.';
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => alignFinderCopy(), { once: true });
  } else {
    alignFinderCopy();
  }

  document.addEventListener('shopify:section:load', (event) => alignFinderCopy(event.target));
})();
